import { Component, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';
import { defaultIfEmpty, map } from 'rxjs/operators';
import { UserRecommendation } from '../../../interfaces/user';
import { RecommendationService } from 'src/app/services/recommendation.service';
import { ResultViewModel } from '../../../models/result-view-model';
import { Brand } from 'src/brands/brand';

@Component({
  selector: 'app-more-tips',
  templateUrl: './more-tips.component.html',
  styleUrls: ['./more-tips.component.scss']
})
export class MoreTipsComponent implements OnDestroy {

  @Input() result?: ResultViewModel;
  public recommendations: UserRecommendation[] = [];

  readonly listLayout = Brand.tipsLayout === 'list';

  private loadSubscription?: Subscription;

  constructor(public recommendationService: RecommendationService) { }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName !== "result" || !changes[propName].currentValue)
        return;

      this.result = changes[propName].currentValue;
      const keys = this.result?.recommendationKeys ?? [];

      // Replaces the whole list, so a result that's loaded again doesn't add every tip a second time
      this.loadSubscription?.unsubscribe();
      this.loadSubscription = forkJoin(keys.map(key =>
        this.recommendationService.getRecommendation(key).pipe(
          map((recommendation): UserRecommendation => ({
            recommendationKey: key,
            viewed: "",
            recommendation: recommendation
          }))
        )
      )).pipe(
        // forkJoin of no keys completes without a value, the list should still be emptied
        defaultIfEmpty([] as UserRecommendation[])
      ).subscribe(recommendations => this.recommendations = recommendations);
    }
  }

  ngOnDestroy(): void {
    this.loadSubscription?.unsubscribe();
  }
}
